export const LAST_ACTIVE_THROTTLE_MS = 5 * 60 * 1000
export const LAST_ACTIVE_STORAGE_PREFIX = 'quillnote.lastActiveAt.'

const memoryWrites = new Map()

export function lastActiveStorageKey(uid) {
  return LAST_ACTIVE_STORAGE_PREFIX + uid
}

// Signup creates the Auth user before the profile document. lastActiveAt is
// an update of that document, so a stamp before the profile exists is
// rejected by the rules and leaves a console error on every new account.
export function canStampLastActiveAt({ signedInUid, loadedProfileUid }) {
  return typeof signedInUid === 'string' &&
    signedInUid.length > 0 &&
    signedInUid === loadedProfileUid
}

export function lastActiveUids({ signedInUid, studentViewStudentId }) {
  const uids = []
  const seen = new Set()

  const add = (uid) => {
    if (typeof uid !== 'string') return
    const trimmed = uid.trim()
    if (!trimmed || seen.has(trimmed)) return
    seen.add(trimmed)
    uids.push(trimmed)
  }

  add(signedInUid)
  add(studentViewStudentId)
  return uids
}

export function shouldWriteLastActiveAt(
  lastWriteMs,
  nowMs,
  throttleMs = LAST_ACTIVE_THROTTLE_MS
) {
  if (!Number.isFinite(nowMs) || nowMs <= 0) return false
  if (!Number.isFinite(lastWriteMs) || lastWriteMs <= 0) return true
  return nowMs - lastWriteMs >= throttleMs
}

export function readLastActiveWriteMs(uid, storage) {
  if (!uid) return 0
  if (memoryWrites.has(uid)) return memoryWrites.get(uid)
  if (!storage || typeof storage.getItem !== 'function') return 0

  try {
    const parsed = parseInt(storage.getItem(lastActiveStorageKey(uid)), 10)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
  } catch (error) {
    return 0
  }
}

export function markLastActiveWriteMs(uid, nowMs, storage) {
  if (!uid || !Number.isFinite(nowMs) || nowMs <= 0) return
  memoryWrites.set(uid, nowMs)
  if (!storage || typeof storage.setItem !== 'function') return

  try {
    storage.setItem(lastActiveStorageKey(uid), String(nowMs))
  } catch (error) {
    // Private mode and quota errors must not break the page.
  }
}

export function clearLastActiveWriteMs(uid, storage) {
  if (!uid) return
  memoryWrites.delete(uid)
  if (!storage || typeof storage.removeItem !== 'function') return

  try {
    storage.removeItem(lastActiveStorageKey(uid))
  } catch (error) {
    // Same as mark: storage is a throttle hint, not a requirement.
  }
}

export function resetLastActiveWriteMemory() {
  memoryWrites.clear()
}
